<template>
  <div>

    <booking-alert-terms-and-conditions
      v-if="canApproveTermsAndConditions"/>

    <booking-alert-talent-attendance-confirmation
      v-if="canConfirmTalentAttendance"
      v-for="user in bookingAttendingTalent"
      :key="`attending-${user.id}`"
      :user="user"/>

    <booking-alert-mark-talent-completed
      v-if="canMarkCompleted"
      v-for="user in bookingAttendingTalent"
      :key="`complete-${user.id}`"
      :user="user"
    />

    <booking-alert-admin-mark-completed v-if="$userIsAdmin && canMarkCompleted" />
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import BookingAlertTalentAttendanceConfirmation from './BookingAlertTalentAttendanceConfirmation'
import BookingAlertTermsAndConditions from './BookingAlertTermsAndConditions'
import BookingAlertUnpaidDeposit from './BookingAlertUnpaidDeposit'
import BookingAlertAdminMarkCompleted from './BookingAlertAdminMarkCompleted'
import BookingAlertMarkTalentCompleted from './BookingAlertMarkTalentCompleted'

export default {
  mixins: [helpers],

  components: {
    BookingAlertTalentAttendanceConfirmation,
    BookingAlertAdminMarkCompleted,
    BookingAlertMarkTalentCompleted,
    BookingAlertTermsAndConditions,
    BookingAlertUnpaidDeposit
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  },

  computed: {
    /**
     * Determine if the logged in user can complete a booking.
     *
     * This action is restricted to only admins and talents, and talents must meet other
     * conditions before being able to mark the booking as completed.
     *
     * @return bool
     */
    bookingCanBeCompletedByUser () {
      // Clients cannot mark a booking as completed...
      if (this.$userIsClient) {
        return false

      // Admins can mark bookings as completed...
      } else if (this.$userIsAdmin) {
        return true

      // Need to check some other things if they're a talent... If they have not yet marked themselves
      // as having attended then they cannot mark the booking as complete.
      } else if (this.$userIsTalent) {
        if (this.bookingAttendingTalentNeedingConfirmation.some(talent => talent.id === this.$user.id)) {
          return false
        }

        return true
      }
    },

    canSeePaymentAlerts () {
      return this.$paymentsModuleEnabled &&
        this.$userIsNotTalent &&
        this.bookingPaymentDepositIsUnpaid &&
        this.bookingTermsAreAccepted
    },

    canConfirmTalentAttendance () {
      return this.bookingTalentAttendanceConfirmationIsOpen &&
        !this.awaitingFirstPayment &&
        this.bookingIsBooked &&
        this.bookingIsNotCompleted &&
        this.$userIsNotClient
    },

    canMarkCompleted () {
      return this.bookingDateHasPassed &&
        !this.awaitingFirstPayment &&
        this.bookingIsBooked &&
        this.bookingIsNotCompleted &&
        this.$userIsNotClient
    },

    canApproveTermsAndConditions () {
      return !this.$vlastMode && this.$userIsNotTalent &&
        this.bookingTermsAreNotAccepted
    },

    awaitingFirstPayment () {
      return this.$paymentsModuleEnabled && this.booking.payments.length && !this.bookingInitialPaymentIsPaid
    }
  }
}
</script>
